import * as c from "../constants/announcements";

/**
 * Announces a message to screen readers via aria-live region
 * @param {string} message - The message to announce
 */
export const announce = (message) => ({
  type: c.ANNOUNCE_MESSAGE,
  payload: message,
});

/**
 * Clears the current announcement
 */
export const clearAnnouncement = () => ({
  type: c.CLEAR_ANNOUNCEMENT,
});
